import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import cookieUniversal from 'cookie-universal';
export default (function (_ref, inject) {
  var req = _ref.req,
      res = _ref.res;
  var options = {
    "alias": "cookies",
    "parseJSON": true
  };
  inject(options.alias, cookieUniversal(req, res, options.parseJSON));
});